// Public pages (legal notices, support, security) are served by the API and
// edited from the admin panel, so they change without a redeploy.

export interface PublicPageSection {
  heading: string;
  paragraphs: string[];
}

export interface PublicPage {
  slug: string;
  eyebrow: string;
  title: string;
  description: string;
  sections: PublicPageSection[];
  /** 0 = built-in default that has never been edited. */
  version: number;
  effective_at: string | null;
}

export async function fetchPublicPage(slug: string): Promise<PublicPage> {
  const apiOrigin = import.meta.env.VITE_API_ORIGIN ?? "";
  const response = await fetch(
    `${apiOrigin}/public/legal/${encodeURIComponent(slug)}`,
    { credentials: "omit" },
  );
  if (!response.ok) {
    throw new Error(`page ${slug} unavailable: ${response.status}`);
  }
  return (await response.json()) as PublicPage;
}
